import { Attendance } from "@/api/openapi";
import { translate } from "@/config/translator";
// eslint-disable-next-line max-len
import { useAttendanceMobileEmployeeHoursTab } from "./attendanceMobileEmployeeHoursTab/useAttendanceMobileEmployeeHoursTab";
import { formatDateFromLangLong } from "@/config/utils";
import { clsx } from "clsx/lite";
import { formatHours } from "../../attendanceUtils";

export type AttendanceMobileEmployeeHoursTabProps = {
  attendance: Attendance;
  month: number;
  year: number;
};

export function AttendanceMobileEmployeeHoursTab({
  attendance,
  month,
  year,
}: AttendanceMobileEmployeeHoursTabProps) {
  const { lang, navigate } = useAttendanceMobileEmployeeHoursTab();

  return (
    <>
      <div className="flex flex-row justify-end text-font-secondary mb-4">
        {`${translate("sum", lang)}: ${attendance.days.reduce(
          (p, d) => p + Number(d.theoreticalHours),
          0,
        )}`}
      </div>

      <div className="flex flex-col">
        {attendance.days.map((day, index, daysArray) => {
          let giustificativiSum = 0;
          let oreBancaOre: number | null = null;
          for (const giustificativo of day.giustificativi) {
            if (giustificativo.type === "SB") {
              oreBancaOre = Number(giustificativo.hours);
            } else {
              giustificativiSum += Number(giustificativo.hours);
            }
          }
          const actualHours = Number(day.actualHours) - giustificativiSum;
          const somethingChanged =
            giustificativiSum !== 0 ||
            Number(day.actualHours) !== Number(day.theoreticalHours);

          return (
            <>
              <button
                onClick={() =>
                  navigate(
                    `/attendances/${attendance.employee.matricola}/${
                      attendance.employee.filiale
                    }/${year}/${month}/${index + 1}`,
                  )
                }
                className={clsx(
                  "flex",
                  "flex-row",
                  "justify-between",
                  "items-center",
                  "py-2",
                  day.isHoliday && "bg-neutral -mx-6 px-6",
                )}
              >
                <div>
                  {formatDateFromLangLong(
                    new Date(year, month - 1, index + 1),
                    lang,
                  )}
                </div>

                <div
                  className={clsx(
                    "relative",
                    "rounded-md",
                    "flex",
                    "flex-row",
                    "px-2",
                    "items-center",
                    "gap-0.5",
                    "bg-canvas-secondary",
                    "h-8",
                    "w-fit",
                    "font-medium",
                  )}
                >
                  <div>{formatHours(actualHours)}h</div>
                  <div className="text-xs mt-2">
                    <span className="text-font-secondary">
                      /{Number(day.theoreticalHours)}h
                    </span>
                    {oreBancaOre && (
                      <span className="text-green-500 ml-1">
                        +{oreBancaOre}
                      </span>
                    )}
                  </div>
                  {somethingChanged && (
                    // Little red dot when something changed
                    <div className="absolute -top-0.5 -right-0.5 size-2 bg-primary rounded-full" />
                  )}
                </div>
              </button>
              {index !== daysArray.length - 1 && (
                <div className="h-px bg-neutral -mx-6" />
              )}
            </>
          );
        })}
      </div>
    </>
  );
}
